<script>
export default {
  name: "drag",
}
</script>

<template>
  <svg data-v-f170a0fb="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21" class="drag-handler"><g fill="none" fill-rule="evenodd"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M15.5 10.5h-7M15.5 14.5h-7M15.5 6.5h-7"></path></g><path fill="currentColor" d="M5.499 7.5c.5 0 1-.5 1-1s-.5-1-1-1-.999.5-.999 1 .499 1 .999 1m0 4c.5 0 1-.5 1-1s-.5-1-1-1-.999.5-.999 1 .499 1 .999 1m0 4c.5 0 1-.5 1-1s-.5-1-1-1-.999.5-.999 1 .499 1 .999 1"></path></g></svg>
</template>
